import { render } from "./WebLogs.vue?vue&type=template&id=397981b5&scoped=true"
import script from "./WebLogs.vue?vue&type=script&lang=js"
export * from "./WebLogs.vue?vue&type=script&lang=js"

import "./WebLogs.vue?vue&type=style&index=0&id=397981b5&lang=scss&scoped=true"
import "./WebLogs.vue?vue&type=style&index=1&id=397981b5&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397981b5"]])

export default __exports__